// extracted by mini-css-extract-plugin
export default {"root":"classes_root__FreOe","icon":"classes_icon__9pJoZ"};